import workRepository from "./workRepository";

export default function createRepository() {
    return {
        workRepository: workRepository(),
    }
}


// WEBPACK FOOTER //
// ./src/repository/index.js